export default "__VITE_ASSET__C8AD059g__"